/**
 * Created by 白 on 2016/12/27.
 */
import { Event } from './event';
import { requestFrame } from './animation';
var refreshEvent = Event();
var last = new Date();
requestFrame(function () {
  var now = new Date();
  refreshEvent.trigger(now - last, now);
  last = now;
});
export default function refresh(task, notImmediately) {
  notImmediately !== true && task(0);
  return refreshEvent.register(task);
}